import { useEffect, useState } from 'react'
import { Range } from 'react-date-range'

import { DateTime } from 'luxon'

type UseRangeProps = {
    rangeKey: string
    color?: string
    useNoon?: boolean
    initialStartDate?: DateTime
    initialEndDate?: DateTime
    timezone?: string
}

export const useDateRange = (props: UseRangeProps) => {
    const {
        rangeKey,
        color,
        useNoon,
        initialStartDate,
        initialEndDate,
        timezone,
    } = props

    const now = DateTime.now().setZone(timezone, { keepLocalTime: true })
    if (useNoon) {
        now.set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
    }

    const [dateRange, setDateRange] = useState<Range>({
        startDate: initialStartDate?.toJSDate() ?? now.toJSDate(),
        endDate: initialEndDate?.toJSDate() ?? now.toJSDate(),
        key: rangeKey,
        color: color,
    })

    const setStartDate = (startDate: Date) => {
        let endDate = dateRange.endDate ?? startDate
        if (startDate > endDate) {
            endDate = startDate
        }

        setRange({ startDate: startDate, endDate: endDate })
    }

    const setEndDate = (endDate: Date) => {
        let startDate = dateRange.startDate ?? endDate
        if (endDate < startDate) {
            startDate = endDate
        }

        setRange({ startDate: startDate, endDate: endDate })
    }

    const setRange = (range: Range) => {
        setDateRange(range)
        // const startDate = DateTime.fromJSDate(
        //     range.startDate ?? now.toJSDate(),
        // ).setZone(timezone)
        // const endDate = DateTime.fromJSDate(
        //     range.endDate ?? now.toJSDate(),
        // ).setZone(timezone)

        // if (useNoon) {
        //     startDate.set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
        //     endDate.set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
        // }

        // setDateRange({
        //     ...dateRange,
        //     startDate: startDate.toJSDate(),
        //     endDate: endDate.toJSDate(),
        // })
    }

    return {
        dateRange,
        setStartDate,
        setEndDate,
        setRange,
    }
}
